<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="primary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Mitglied bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm6>
              <v-text-field
                label="Unternehmensbezeichnung"
                required
                v-model="localMember.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field label="Logo" @click='pickFile' v-model='imageName' prepend-icon='attach_file'>
              </v-text-field>
              <v-img
                v-if="imageUrl"
                :src="imageUrl"
                height="150"
                contain></v-img>
              <input type="file" @change="showThumbnail" ref="pictureInput" style="display: none" accept="image/*"/>
            </v-flex>
            <v-flex sm6>
              <v-select
                :items="items"
                label="Branche"
                item-text="title"
                item-value="id"
                v-model="localMember.branch"
              ></v-select>
            </v-flex>
            <v-flex sm6>
              <v-select
                :items="items"
                label="Branche#2"
                item-text="title"
                item-value="id"
                v-model="localMember.branch2"
              ></v-select>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                label="Web Adresse"
                required
                v-model="localMember.web"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Email"
                v-model="localMember.email"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Telefonnummer"
                v-model="localMember.phone"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Adresse"
                v-model="localMember.address"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-textarea
                label="Öffnungszeiten"
                v-model="localMember.openingTimes"
                :disabled="loading"></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="update()" :loading="loading">Speichern</v-btn>
        <v-btn color="error" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import awsExport from '@/aws-exports';

export default {
  name: 'DlgCommitteeNew',
  components: {
  },
  data() {
    return {
      dialog: false,
      loading: false,
      localMember: {},
      image: null,
      items: [],
      bucketName: awsExport.aws_user_files_s3_bucket,
      s3Region: awsExport.aws_user_files_s3_bucket_region,
      imageUrl: null,
      imageName: null,
      // eslint-disable-next-line max-len
    };
  },
  props: ['member'],
  computed: {
    ...mapGetters({
      branches: 'branch/all',
    }),
  },
  methods: {
    ...mapActions({
      memberUpdate: 'member/update',
      memberRead: 'member/read',
      branchRead: 'branch/read',
    }),
    update() {
      this.loading = true;
      this.memberUpdate({ user: this.localMember, image: this.$refs.pictureInput.files[0] }).then((res) => {
        this.loading = false;
        if (res) {
          this.memberRead();
          this.localMember = {};
          this.dialog = false;
        }
      });
    },
    onChange() {
      this.image = this.$refs.pictureInput.file;
    },
    showThumbnail() {
      this.imageUrl = URL.createObjectURL(this.$refs.pictureInput.files[0]);
      this.imageName = this.$refs.pictureInput.files[0].name;
    },
    pickFile() {
      this.$refs.pictureInput.click();
    },
  },
  watch: {
    dialog() {
      this.localMember = JSON.parse(JSON.stringify(this.member));
      this.imageUrl = this.member.imageUrl;
      this.loading = true;
      this.branchRead().then(() => {
        this.loading = false;
        this.items = this.branches;
      });
    },
  },
};
</script>

<style scoped>

</style>
